import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SliceBaseGeneralSettings, SliceBaseSettings } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { IdtComponentSettings, SlotSettings } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'render-slice-slot[slice][slot]',
  templateUrl: 'render-slice-slot.component.html',
  styleUrls: ['render-slice-slot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RenderSliceSlotComponent implements OnInit {

  @Input() public slice!: IdtComponent;
  @Input() public slot!: string;

  public settings$!: Observable<unknown>;
  public piece$!: Observable<IdtComponent>;
  public country$!: Observable<string | null>;
  public lang$!: Observable<string | null>;

  constructor(
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService
  ) {}

  public get currentSlot(): SlotSettings | undefined {
    const slotsInSlice = (this.slice.settings as SliceBaseSettings<SliceBaseGeneralSettings>).slots ?? [];
    return slotsInSlice.length > 0 ? slotsInSlice[+this.slot - 1] : undefined;
  }

  public ngOnInit(): void {
    if (this.slice) {
      const slug = this.renderSlugService.getSlug();
      this.piece$ = this.renderStateService.getSlotComponents$(slug, this.slice.id, this.slot).pipe(
        filter((components) => components[0] !== undefined),
        map((components) => components[0])
      );

      this.country$ = this.renderStateService.getCountry$(slug);
      this.lang$ = this.renderStateService.getLanguage$(slug);

      this.settings$ = this.piece$.pipe(
        filter((piece) => !!piece),
        map((piece) => piece.settings as IdtComponentSettings)
      );
    }
  }

  public pieceId(piece: IdtComponent | null): string | null {
    return piece?.id ?? null;
  }

  public isSlice(piece: IdtComponent | null): boolean {
    return !!piece?.definitionId?.startsWith('slice');
  }

}
